export default class VkontakteAPI {
  constructor ({ apiId = 2913841 }) {
    // make required container first
    const c = document.createElement('div')
    c.setAttribute('id', 'vk_api_transport')
    document.body.appendChild(c)

    window.vkAsyncInit = () =>
      window.VK.init({ apiId })

    setTimeout(() => {
      var el = document.createElement('script')
      el.type = 'text/javascript'
      el.src = 'https://vk.com/js/api/openapi.js'
      el.async = true
      document.getElementById('vk_api_transport').appendChild(el)
    }, 0)

    this.authURL = [
      'https://oauth.vk.com/authorize?client_id=', apiId,
      '&display=page&redirect_uri=', window.location,
      '&response_type=code'
    ].join('')
  }

  getStatus () {
    return new Promise((resolve, reject) =>
      window.VK.Auth.getLoginStatus(({ status }) =>
        status === 'connected' ? resolve(status) : reject(status)))
  }

  login = (settings = 8192) => {
    return new Promise((resolve, reject) => {
      const vkWindow = window.open(this.authURL)
      vkWindow.addEventListener('load', () => {
        const code = vkWindow.location.href.match(/\?code=(\w+)/)[1]
        if (code) resolve(code) || vkWindow.close()
        else reject()
      })
    })
  }

  wallPost ({ message, link, v = 5 }) {
    return new Promise((resolve, reject) =>
      window.VK.Api.call('wall.post', { message, attachments: link, v }, ({ response, error }) =>
        error ? reject(error) : resolve(response.post_id)))
  }
}



// WEBPACK FOOTER //
// app/javascript/src/services/social/vk.js